// ServiceCards.js
import React from "react";
import { FaPhone, FaSimCard, FaTv } from "react-icons/fa";
import "../styles/serviceCard.css"; 
import {Link} from "react-router-dom"


const ServiceCards = () => {
  const services = [
    {
      icon: <FaPhone />,
      title: "Airtime",
      description:
        "Enjoy as much as 3% discount on airtime purchase on our platform. We offer VTU airtime for MTN, Glo, Airtel and 9mobile.",
      buttonText: "Buy Airtime",
      borderColor: "#0C464A", // Deep teal
    },
    {
      icon: <FaSimCard />,
      title: "Data",
      description:
        "Buy and resell cheap data on subnetexpress.com and make money with us. We offer the cheapest data bundles for all networks.",
      buttonText: "Buy Data",
       borderColor: "#0C464A", // Deep teal
    },
    {
      icon: <FaTv />,
      title: "Cable TV",
      description:
        "Don't miss that TV programme. Subscribe your Cable TV (DSTV, GOTV & Startimes) at the cheapest price. Instant activation!",
      buttonText: "Subscribe Cable TV",
       borderColor: "#0C464A", // Deep teal
    },
  ];

  return (
     <div className="cards-container">
      {services.map((card, index) => (
        <div key={index} className="service-card" style={{ borderTopColor: card.borderColor }}>
          <div className="card-icon-wrapper" style={{ backgroundColor: card.borderColor }}>
            <div className="card-icon">{card.icon}</div>
          </div>
          <h5>{card.title}</h5>
          <p>{card.description}</p>
           <Link to="/dashboard" className="my-cstm-btn-link">
          <button className="card-btn">{card.buttonText}</button>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default ServiceCards;
